import React, {useContext} from 'react';

import StayContext from '../../context/StayContext';
import VaWrap from '../../VaWrap/VaWrap';

import {VaControllerContext} from '../../context/VaControllerContext';

export const VaController = ({getHelpText, onDismissHelpText}) => {
    const {
        stay: {
            booking: {reservationUuid},
        },
    } = useContext(StayContext);

    const {
        store: {
            autoOpen,
            chatWidgetCounter,
            eventsInfo,
            vaIntent,
            isLoading,
            showVA,
        },
        actions: {updateIsLoading},
    } = useContext(VaControllerContext);
    return (
        showVA && (
            <VaWrap
                autoOpen={autoOpen}
                chatWidgetCounter={chatWidgetCounter}
                eventsInfo={eventsInfo}
                getHelpText={getHelpText}
                intent={vaIntent}
                isLoading={isLoading}
                onDismissHelpText={onDismissHelpText}
                otherIntentProps={{
                    reservationUuid,
                }}
                updateIsLoading={updateIsLoading}
            />
        )
    );
};
